import { useState, MouseEvent, FC } from 'react';
import { Draggable } from 'react-beautiful-dnd';

import classNames from 'classnames';
import { Trash2, Pencil } from 'lucide-react';
import { BaseMenu, BaseMenuItem } from 'wbs-components-lib';

import { Box, Typography } from '@mui/material';

import { textStyles } from '@shared/styles';

import { VipLevelRewardProps } from './types';

import styles from './VipLevelReward.module.css';

const { actionsContainer, vipLevelActionItem, vipRewardItemDraggable } = styles;

const { defaultText } = textStyles;

export const VipLevelReward: FC<VipLevelRewardProps> = ({
  index,
  vipLevel,
  vipLevelReward,
  handleVipLevelRewardEditModalOpen,
  handleVipLevelRewardDeleteModalOpen,
}) => {
  const { id, title, reuseInterval } = vipLevelReward;

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpened = Boolean(menuAnchor);

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const menuItems: BaseMenuItem[] = [
    {
      icon: <Pencil />,
      text: 'Edit',
      onClick: () => handleVipLevelRewardEditModalOpen(vipLevelReward, vipLevel),
    },
    {
      icon: <Trash2 />,
      text: 'Delete',
      onClick: () => handleVipLevelRewardDeleteModalOpen(vipLevelReward),
    },
  ];

  return (
    <Draggable key={id} draggableId={id} index={index}>
      {(provided, snapshot) => (
        <Box
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          className={classNames({
            [vipLevelActionItem]: true,
            [vipRewardItemDraggable]: snapshot.isDragging,
          })}
        >
          <Typography className={defaultText}>Title: {title}</Typography>
          <Typography className={defaultText}>
            {reuseInterval ? `Reuse interval: ${reuseInterval}` : 'Single use'}
          </Typography>
          <Box className={actionsContainer}>
            <Typography className={defaultText}>Settings:</Typography>
            <BaseMenu
              menuItems={menuItems}
              menuAnchor={menuAnchor}
              isMenuOpened={isMenuOpened}
              handleOpenMenu={handleOpenMenu}
              handleCloseMenu={handleCloseMenu}
            />
          </Box>
        </Box>
      )}
    </Draggable>
  );
};
